<template>
  <div
      class="form__step"
      sklepalnik-ui-formgroup
      :touched="touched"
      :valid="valid"
  >
    <h1 class="form__step-title">{{ currentStepTitle }}</h1>

    <slot></slot>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  methods: {
    onChildInit(child) {
      if (child.$el.hasAttribute("sklepalnik-ui-element")) {
        if (child.hasValidator && child.hasValidator()) {
          this.elementsToValidate.push(child);
        }

        if (child.$el.hasAttribute("track-fg-change")) {
          child.$on("fg-value-change", () => {
            Vue.nextTick(() => {
              this.fieldValueChanged(child);
            });
          });
        }
      }

      if (child.$vnode.componentOptions.tag === "ui-button") {
        child.$on("click", (e) => {
          this.handleButtonClick(child, e);
        });
      }

      child.$on("change", () => {
        this.touched = true;
        this.$emit("touched");
      });

      child.$on("validated", () => {
        if (!this.elementsToValidate.includes(child)) this.elementsToValidate.push(child);
        Vue.nextTick(() => {
          this.determineValid();
        });
      });

      this.elements.push(child);

      Vue.nextTick(this.determineValid);
    },
    onChildDestroyed(child) {
      const el_i = this.elements.indexOf(child);
      const elv_i = this.elementsToValidate.indexOf(child);

      this.elements.splice(el_i, 1);
      this.elementsToValidate.splice(elv_i, 1);
      this.determineValid();
    },
    determineValid() {
      let result = true;

      for (const etv of this.elementsToValidate) {
        if (!etv.valid) {
          result = false;
          break;
        }
      }

      for (const nfg of this.nestedFormGroups) {
        if (!nfg.determineValid()) {
          result = false;
          break;
        }
      }

      this.valid = result;
      this.$emit('validated', result);
      return this.valid;
    },
    handleButtonClick(button, event) {
      if (button.$el.hasAttribute("fg-validate")) {
        const result = this.validatorClicked();

        if (result) {
          if (button.$el.hasAttribute("fg-progress-next")) {
            this.progressNextClicked(event);
          } else if (button.$el.hasAttribute("fg-submit")) {
            this.submitClicked();
          }
        }
      } else if (button.$el.hasAttribute("fg-progress-next")) {
        this.progressNextClicked(event);
      } else if (button.$el.hasAttribute("fg-progress-back")) {
        this.progressBackClicked();
      } else if (button.$el.hasAttribute("fg-submit")) {
        this.submitClicked();
      }
    },
    validatorClicked() {
      const results = [];
      for (const c of this.elementsToValidate) {
        results.push(c.runValidator());
      }

      for (const nfg of this.nestedFormGroups) {
        results.push(nfg.validatorClicked());
      }

      return results.length === 0 || results.every((r) => r);
    },
    onElementValidateChanged(element) {
      if (element.hasValidator()) {
        if (!this.elementsToValidate.includes(element)) {
          this.elementsToValidate.push(element);
        }
      } else {
        if (this.elementsToValidate.includes(element)) {
          const i = this.elementsToValidate.indexOf(element);
          this.elementsToValidate.splice(i, 1);
        }
      }
    },
    fieldValueChanged(field) {
      this.$emit("field-value-change", {
        name: field.name,
        value: field.value,
      });
    },
    /* CE FORM GROUP NESTAS, NPR IMAS KOMPONENTO, KI IMA FORM GROUP, IN POTEM JE NOTRI SE ENA KOMPONENTA, KI IMA SPET FORM GROUP, MORAS V CHILD KOMPONENTI ZAVIT FORM GROUP V DIV, TOREJ <template><div><ui-formgroup></ui-formgroup></div></template> IN NE FORM GROUP NA ROOTU!! */
    onNestedFormGroupInit(nestedFG) {
      if (nestedFG.$el.hasAttribute("sklepalnik-ui-formgroup")) {
        this.nestedFormGroups.push(nestedFG);
      }
    },
    onNestedFormGroupDestroy(nestedFG) {
      const i = this.nestedFormGroups.indexOf(nestedFG);
      if (i > -1) this.nestedFormGroups.splice(i, 1);
    },
    detectNestedFG() {
      let parent = this.$parent;

      while (
          parent &&
          parent.$vnode &&
          parent.$el &&
          [1, 8].includes(parent.$el.nodeType)
          ) {
        if (parent.$el.hasAttribute) {
          if (parent.$el.hasAttribute("sklepalnik-ui-formgroup")) {
            this.parentFG = parent;
            this.parentFG.onNestedFormGroupInit(this);
            break;
          }
        }

        parent = parent.$parent;
      }
    },
    progressNextClicked() {
      this.$emit("fg-progress-next");
    },
    progressBackClicked() {
      this.$emit("fg-progress-back");
    },
    submitClicked() {
      this.$emit("fg-submit");
    },
    moveNext() {
      const progressNextButton = this.elements.find(el => el.$el.hasAttribute('fg-progress-next'));

      if (progressNextButton) {
        progressNextButton.onclick();
      } else {
        const valid = this.validatorClicked();

        if (valid) {
          this.progressNextClicked();
        }
      }
    },
    isTouched() {
      return this.touched;
    },
    isValid() {
      return this.valid;
    },
    onEnterKeyPressed() {
      const keyDownEnterClickButton = this.elements.find(el => el.$el.hasAttribute('fg-keydown-enter-click'));

      if (keyDownEnterClickButton) {
        keyDownEnterClickButton.onclick(new MouseEvent('click'));
      }
    }
  },
  data: function () {
    return {
      elements: [],
      elementsToValidate: [],
      validateTrigger: undefined,
      nestedFormGroups: [],
      parentFG: undefined,
      touched: false,
      valid: false,
      currentStepTitle: undefined
    };
  },
  mounted() {
    this.$emit("fg-init");
    this.detectNestedFG();
  },
  destroyed() {
    if (this.parentFG) {
      this.parentFG.onNestedFormGroupDestroy(this);
    }
  },
};
</script>

<style>
</style>
